/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/hypot.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns the hypotenuse of two numbers. The input can be any numeric values, the return value is always a double.
 * Hypotenuses of infinities are null.
 *
 * @example
 * ROW a = 3.0, b = 4.0
 * | EVAL c = HYPOT(a, b)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'hypot',
  signatures: [
    {
      params: [
        {
          name: 'number1',
          type: 'double',
          optional: false,
        },
        {
          name: 'number2',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number1',
          type: 'double',
          optional: false,
        },
        {
          name: 'number2',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number1',
          type: 'double',
          optional: false,
        },
        {
          name: 'number2',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number1',
          type: 'double',
          optional: false,
        },
        {
          name: 'number2',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number1',
          type: 'integer',
          optional: false,
        },
        {
          name: 'number2',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number1',
          type: 'integer',
          optional: false,
        },
        {
          name: 'number2',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number1',
          type: 'integer',
          optional: false,
        },
        {
          name: 'number2',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number1',
          type: 'integer',
          optional: false,
        },
        {
          name: 'number2',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number1',
          type: 'long',
          optional: false,
        },
        {
          name: 'number2',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number1',
          type: 'long',
          optional: false,
        },
        {
          name: 'number2',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number1',
          type: 'long',
          optional: false,
        },
        {
          name: 'number2',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number1',
          type: 'long',
          optional: false,
        },
        {
          name: 'number2',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number1',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'number2',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number1',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'number2',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number1',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'number2',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number1',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'number2',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
